import React, { useState, useEffect } from 'react';
import { historyAPI } from '../services/api';
import { Clock, Search, Mail } from 'lucide-react';

export default function HistoryPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { historyAPI.list().then(({ data }) => { setLogs(data.results || data || []); setLoading(false); }).catch(() => setLoading(false)); }, []);

  if (loading) return <div className="page-container"><div className="loading-spinner"><div className="spinner" /></div></div>;

  return (
    <div className="page-container">
      <div className="page-header"><div><h1 className="page-title">Search & Email History</h1><p className="page-subtitle">Logged from the History table</p></div></div>
      {logs.length === 0 ? (
        <div className="empty-state"><Clock size={48} /><p>No history records yet.</p></div>
      ) : (
        <div className="card"><div className="table-wrapper">
          <table className="data-table">
            <thead><tr><th>ID</th><th>User ID</th><th>Keyword / Action</th><th>Date</th><th>IP Address</th><th>Mail Sent</th></tr></thead>
            <tbody>
              {logs.map(h => (
                <tr key={h.historyid} style={{ cursor: 'default' }}>
                  <td style={{ fontFamily: 'var(--font-mono)', fontSize: '.84rem' }}>{h.historyid}</td>
                  <td style={{ fontSize: '.85rem' }}>{h.userid || '—'}</td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '.88rem' }}>
                      {h.sendmail > 0 ? <Mail size={14} style={{ color: 'var(--accent)', flexShrink: 0 }} /> : <Search size={14} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />}
                      <span style={{ maxWidth: 400, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{h.keyword || '—'}</span>
                    </div>
                  </td>
                  <td style={{ fontSize: '.82rem', color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>{h.searchdate ? new Date(h.searchdate).toLocaleString() : '—'}</td>
                  <td style={{ fontFamily: 'var(--font-mono)', fontSize: '.82rem' }}>{h.ipaddress || '—'}</td>
                  <td>{h.sendmail > 0 ? <span style={{ fontFamily: 'var(--font-mono)', color: 'var(--accent)', fontWeight: 600 }}>{h.sendmail}</span> : <span style={{ color: 'var(--text-muted)' }}>—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div></div>
      )}
    </div>
  );
}
